export default {
  methods: {
    generateLocationImagePath(location) {
      let timestamp = Date.now();
      return `locations/${location.id}/profile-images/${timestamp}`;
    },

    generateUserImagePath(user) {
      let timestamp = Date.now();
      return `users/${user.uid}/profile-images/${timestamp}`;
    }
  }
};
